import type { IEtazhiBlackFridayPromoOffersData } from 'shared/types/etazhiBlackFriday';

import { getIsStartDatePassed } from './getIsStartDatePassed';

export function getIsRSEnabled(promoOffersData: IEtazhiBlackFridayPromoOffersData | null): boolean {
  /**
   * РС полностью выкл. или нет данных (выставлены в null в RS)
   */
  if (!promoOffersData || !promoOffersData.desktop) {
    return false;
  }

  const { desktop: data } = promoOffersData;

  /**
   * Выставлен флаг "выключен" для конкретного типа устройств (desktop)
   */
  if (!data.enabled) {
    return false;
  }

  /**
   * Выставлена дата запуска кампании, и она ещё не наступила
   */
  const isStartDatePassed = getIsStartDatePassed(data);

  return isStartDatePassed;
}
